import { Input, styled } from '@mui/material';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledInput = styled(Input)(({ theme }) => ({
  width: '100%',
  fontFamily: fontFamily.drukWideMedium,
  fontWeight: 500,
  fontSize: theme.spacing(4),
  paddingX: theme.spacing(1),
  paddingY: theme.spacing(0.5),
  fontStretch: 'normal',
  fontStyle: 'normal',
  outline: 'none',
  background: 'none',
  '.MuiInputBase-input': {
    padding: 0,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  '&.Mui-focused': {
    outline: '1px solid',
    outlineColor: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[700],
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[700],
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(2.75),
  },
}));
